
//使用钩子函数对路由进行权限跳转
import router from "./router";
import chatDataCenter from "./jsSdk/chatDataCenter";
import messageBox from "./components/common/message/messageBox";
import common from "./utils/common";

const checkList = [
    '/web'
];
router.beforeEach((to, from, next) => {
  if(to.meta.title){
    document.title = to.meta.title;
  }
    if (common.isMobile()) {
        chatDataCenter.chatTerminal='H5';
    }else {
        chatDataCenter.chatTerminal='WEB';
    }
    if(checkList.indexOf(to.path) >-1){
        if(to.query.thirdId){
            if ((!chatDataCenter.linkInfo.thirdId)||(chatDataCenter.linkInfo.thirdId&&to.query.thirdId!=chatDataCenter.linkInfo.thirdId)){
                chatDataCenter.getLinkByThirdId(to.query.thirdId,response=>{
                    if (response.code==0) {
                        chatDataCenter.linkInfo = response.data;
                        chatDataCenter.set.windowSize=chatDataCenter.linkInfo.windowSize
                        if(to.query.frame){
                            chatDataCenter.set.isIFrame = true;
                        }else {
                            chatDataCenter.set.isIFrame = false;
                        }
                        chatDataCenter.getChannelInfo(response.data.channelId,channelRes=>{
                            if (channelRes.code==0){
                                chatDataCenter.channelInfo = channelRes.data;
                                if (chatDataCenter.channelInfo&&chatDataCenter.channelInfo.channelId){
                                    if (to.path=='/web'){
                                        chatDataCenter.createCustomerByPage(null,to,to.query, response.data.companyId,response.data.thirdId,response.data.channelId,function (data) {
                                            if(data&&data.customerCode){
                                                next()
                                            }
                                        });
                                    }else {
                                        messageBox.Error({message:'系统异常,请联系管理员：检查配置',duration:3000});
                                    }
                                }else {
                                    messageBox.Error({message:'系统异常,请联系管理员:无渠道',duration:3000});
                                }
                            }else {
                                messageBox.Error({message:'系统异常,请联系管理员:'+channelRes.msg,duration:3000});
                            }
                        })
                    }else{
                        messageBox.Error({message:'系统异常,请联系管理员:无接入方式',duration:3000});
                    }
                });
            }else {
                next()
            }
        }else {
            messageBox.Error({message: '请先配置接入thirdId',duration: 3000});
        }
    }else {
        next()
    }
});
router.afterEach((to, from) => {
    // 通过config接口注入权限验证配置，我封装在了 vuex 里

});
